import type { TableData, TableProps } from './Table';
import { TableHeaderCell } from './TableHeaderCell';
import type { TableRowProps } from './TableRow';
import { TableRow } from './TableRow';

type TableHeaderProps<Data extends TableData> = Required<Pick<TableProps<Data>, 'columns'>> &
  Pick<TableRowProps, 'style' | 'hasSidePadding'>;

export const TableHeader = <Data extends TableData>({
  columns,
  style,
  hasSidePadding,
}: TableHeaderProps<Data>) => {
  return (
    <TableRow style={style} hasSidePadding={hasSidePadding} isHeaderRow>
      {columns.map(({ name, label, align, noRightPadding }, colIndex) => {
        const isLastColumn = colIndex === columns.length - 1;
        const finalHasRightPadding = !(noRightPadding ?? !isLastColumn);

        return (
          <TableHeaderCell noRightPadding={finalHasRightPadding} align={align} key={String(name)}>
            {label}
          </TableHeaderCell>
        );
      })}
    </TableRow>
  );
};
